import { render, staticRenderFns } from "./dateChooserCentral.vue?vue&type=template&id=b8d176b6&"
import script from "./dateChooserCentral.vue?vue&type=script&lang=ts&"
export * from "./dateChooserCentral.vue?vue&type=script&lang=ts&"
import style0 from "./dateChooserCentral.vue?vue&type=style&index=0&id=b8d176b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports